import React from "react"
import ReactDOM from 'react-dom/client';
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"

import store from "./store"
import "./assets/custom-css/custom.css";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
      <>
      <BrowserRouter basename={process.env.REACT_APP_FRONTEND_ENPPOINT}>
        <App />
      </BrowserRouter>
  </>
    </Provider>
);

serviceWorker.unregister()
